import { render } from "./ShuftiSuccess.vue?vue&type=template&id=25d0519f&scoped=true"
import script from "./ShuftiSuccess.vue?vue&type=script&lang=js"
export * from "./ShuftiSuccess.vue?vue&type=script&lang=js"

import "./ShuftiSuccess.vue?vue&type=style&index=0&id=25d0519f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d0519f"]])

export default __exports__